import type { ItemCategory, ItemDef, Stats } from "../types";
import { ZERO_STATS } from "../modules/define";

interface ItemInput {
  id: string;
  name: string;
  category: ItemCategory;
  sizeM: number;
  sprite: string;
  stats: Partial<Stats>;
  resource?: string | null;
}

export function defineItem(input: ItemInput): ItemDef {
  return {
    id: input.id,
    name: input.name,
    category: input.category,
    sizeM: input.sizeM,
    sprite: input.sprite,
    stats: { ...ZERO_STATS, ...input.stats },
    resource: input.resource ?? null,
  };
}
